var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVisa = function SvgIconVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#86868B",
    d: "M16.04 11.801h-3.015L14.915.21h3.022zM10.484.21 7.602 8.183l-.339-1.716-1.015-5.212A1.29 1.29 0 0 0 4.814.21H.055L0 .4a11.3 11.3 0 0 1 3.158 1.324L5.78 11.795h3.145L13.726.203zM34.23 11.801H37L34.587.21h-2.425a1.38 1.38 0 0 0-1.391.862l-4.512 10.724h3.145l.628-1.723h3.841zm-3.324-4.104 1.588-4.338.893 4.338zm-4.413-4.7.43-2.492A8.7 8.7 0 0 0 24.21 0c-1.496 0-5.053.652-5.053 3.84 0 2.996 4.173 3.033 4.173 4.602s-3.749 1.292-4.98.301l-.45 2.603c1.078.45 2.241.677 3.41.652 2.063 0 5.171-1.064 5.171-3.968 0-3.015-4.216-3.292-4.216-4.603s2.942-1.144 4.229-.43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#AAA",
    d: "M7.263 6.466 6.248 1.254A1.29 1.29 0 0 0 4.814.208H.055L0 .398a11.6 11.6 0 0 1 4.481 2.253 9 9 0 0 1 2.782 3.815"
  })));
};
export default SvgIconVisa;